import { IconsDirective } from '@awork/_shared/directives/icons/icons.directive'
import { FileIconComponent } from '@awork/_shared/components/file-icon/file-icon.component'
import { getAvatarInitialsColor } from '@awork/_shared/functions/avatar-initials'
import { Component, computed, input, signal } from '@angular/core'

/** Semantic color of a content row's text and leading icon. */
export type ContentRowTone = 'default' | 'danger'

/** Layout for a mobile field or read-only row. Projected controls own all interaction. */
@Component({
  selector: 'aw-content-row',
  templateUrl: './content-row.component.html',
  styleUrl: './content-row.component.scss',
  imports: [IconsDirective, FileIconComponent]
})
export class ContentRowComponent {
  /** Selector rows use larger leading visuals and no card inset. */
  readonly variant = input<'default' | 'selector'>('default')
  readonly avatarShape = input<'square' | 'round'>('square')
  readonly initials = input<string>()
  /** Keeps warning text and its leading icon visible in read-only rows. */
  readonly tone = input<ContentRowTone>('default')
  /** Optional emoji tile; takes priority over images and icons. */
  readonly fileName = input<string>()
  readonly emoji = input<string>()
  readonly iconBadge = input(false)
  readonly icon = input<string>()
  /** Uses the entity color for a selector icon, such as a team avatar, or `neutral` for actions such as Clear. */
  readonly iconColor = input<string>()
  /** Leading image, like an avatar. Wins over the icon. */
  readonly image = input<string>()
  private readonly failedImage = signal<string | undefined>(undefined)
  protected readonly initialsColor = computed(() => getAvatarInitialsColor(this.initials()))
  protected readonly visibleImage = computed(() => (this.image() !== this.failedImage() ? this.image() : undefined))

  /** Uses initials or the entity icon when an image cannot load. */
  protected onImageError(): void {
    this.failedImage.set(this.image())
  }
}
